var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"page-loader text-center"},[_c('CSpinner',{attrs:{"color":"primary","size":"lg"}})],1)]):_vm._e(),(!_vm.loading)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }